<template>
  <div class="flex w-full center items-center justify-between">
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      All clients
    </h3>
      <button
          type="button"
          class="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success sm:text-sm"
          @click="showCreateFrom = !showCreateFrom"
      >
          <!-- Heroicon name: solid/plus-sm -->
          <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
          >
              <path
                  fill-rule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clip-rule="evenodd"
              />
          </svg>
          <p>New Client</p>
      </button>
  </div>
  <client-list
    class="mt-5"
    :clients="clients"
  />

  <div class="relative mt-5 bg-white overflow-hidden shadow rounded-lg" />
  <Modal
    :show="showCreateFrom"
    max-width="md"
    :closeable="true"
    @close="showCreateFrom = false"
  >
    <CreateClientForm @close="showCreateFrom = false" />
  </Modal>
</template>
<script>
import ClientList from '../../ComponentsDeprecated/ClientList.vue';
import Modal from '../../Jetstream/Modal.vue';
import CreateClientForm from '../../ComponentsDeprecated/CreateClientForm.vue';

export default {
  components: {
    ClientList,
    Modal,
    CreateClientForm,
  },
  props: {
    clients: Array,
  },
  data() {
    return {
      showCreateFrom: false,
    };
  },
};
</script>

<style lang="scss" scoped>
//
</style>
